import React from 'react'
import { Popup, Form, Button, Input, Modal, Toast } from 'antd-mobile'
import styles from './index.scss'
import useLang from '@/libs/hooks/useLang'

export interface ThirdCodeModalProps {
  h5Setting?: Record<string, any>
  customStyle?: React.CSSProperties
  visible?: boolean
  onClose?: () => void
  onOk?: (values: Record<string, any>) => void
}

const ThirdCodeModal: React.FC<ThirdCodeModalProps> = ({
  h5Setting = {},
  customStyle,
  visible,
  onClose,
  onOk,
}) => {
  const { t } = useLang('prompt_util')
  const {
    succeedVerifyTitle = '',
    succeedVerifyDesc = '',
    succeedVerifyButtonText = '',
    succeedVerifyCodes = [],
  } = h5Setting

  const showUserName = succeedVerifyCodes.includes('userName')
  const showMemberTag = succeedVerifyCodes.includes('memberTag')
  const showGuestCode = succeedVerifyCodes.includes('guestCode')

  const onFinish = async (values: any = {}) => {
    if (showUserName && !values.userName) {
      Toast.show({
        content: t('userNamePlaceholder2', '请输入用户名'),
      })
      return
    }
    if (showMemberTag && !values.memberTag) {
      Toast.show({
        content: t('memberTagPlaceholder', '请输入激活码'),
      })
      return
    }
    if (showGuestCode && !values.guestCode) {
      Toast.show({
        content: t('guestCodePlaceholder', '请输入客户编号'),
      })
      return
    }
    onOk && onOk(values)
  }

  return (
    <Modal
      className={styles.modal}
      visible={visible}
      // onMaskClick={onClose}
      showCloseButton
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      }}
      onClose={onClose}
      content={
        <div className={styles.container} style={customStyle}>
          <div className={styles.title}>
            {succeedVerifyTitle ?? t('memberTagVerify', '激活码认证')}
          </div>
          <Form
            // form={form}
            className={styles.form}
            layout="horizontal"
            onFinish={onFinish}
            footer={
              <>
                <Button
                  className={styles.footerBtn}
                  style={customStyle}
                  block
                  shape="rounded"
                  // loading={loading}
                  type="submit"
                  color="primary"
                >
                  {succeedVerifyButtonText}
                </Button>
                <div className={styles.tips}>{succeedVerifyDesc}</div>
              </>
            }
          >
            {showUserName && (
              <Form.Item className={styles['form-item']} name="userName">
                <Input
                  type="text"
                  clearable
                  placeholder={t('fullnamePlaceholder', '请输入姓名')}
                />
              </Form.Item>
            )}

            {showMemberTag && (
              <Form.Item className={styles['form-item']} name="memberTag">
                <Input
                  type="text"
                  clearable
                  placeholder={t('memberTagPlaceholder', '请输入激活码')}
                />
              </Form.Item>
            )}

            {showGuestCode && (
              <Form.Item className={styles['form-item']} name="guestCode">
                <Input
                  type="text"
                  clearable
                  placeholder={t('guestCodePlaceholder', '请输入客户编号')}
                />
              </Form.Item>
            )}
          </Form>
        </div>
      }
    ></Modal>
  )
}

export default ThirdCodeModal
